import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import useCollectionState from 'Hooks/useCollectionState';
import DataContainer from 'Components/UI/DataContainer';
import {
  HouseholdBalanceSheetPage,
} from 'Views/Page/Content/Templates/HouseholdBalanceSheetPageTemplate/HouseholdBalanceSheetPage';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { FDPaper } from '@facet-wealth/design';

export const MissionControlBalanceSheetTab = ({ relationship, className }) => {
  const {
    collection, setCollection, refreshCollection, isInitializing, loadingError,
  } = useCollectionState({ link: relationship.link('related').url() });
  const { loadPageContentLink } = usePageContentContext();

  // We want to refresh the collection automatically whenever a modal closes.
  // The goal is to do this with a useEffect that has only 1 dependency it's watching - if a modal is closed
  const { modalCollection } = useModalContext();
  const modalClosed = !modalCollection;
  // However, we also need to pass in the refresh function, which changes when we refresh.
  // To avoid an infinite loop, we'll need to access the function via a ref
  const refreshCollectionRef = useRef();
  refreshCollectionRef.current = refreshCollection;
  // Now we can set up the effect
  useEffect(() => {
    if (modalClosed) {
      refreshCollection();
    }
  }, [modalClosed]);

  return (
    <div className={className}>
      <FDPaper appearance="flat" color="subtle" rounded={false}>
        <DataContainer
          loading={isInitializing}
          loadingError={loadingError}
          component={HouseholdBalanceSheetPage}
          componentProps={{
            collection,
            setCollection,
            resource: collection?.resources()?.head(),
            refresh: refreshCollection,
            navigate: loadPageContentLink,
            condensed: true,
          }}
        />
      </FDPaper>
    </div>
  );
};

MissionControlBalanceSheetTab.defaultProps = {
  className: undefined,
};
MissionControlBalanceSheetTab.propTypes = {
  relationship: PropTypes.object.isRequired,
  className: PropTypes.string,
};
